import { Injectable } from '@angular/core';
import {PollingService} from "../../../services/polling.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramNotificationsPollingService extends PollingService {}
